import { StatCard } from '../StatCard';
import { useWidgetData, aggregate, accentMap, currencyFmt } from './shared';
import type { DashboardWidget } from '../../types/panelConfig';

interface StatWidgetProps {
  widget: Extract<DashboardWidget, { type: 'stat' }>;
  sourceId: number | null | undefined;
}

export function StatWidget({ widget, sourceId }: StatWidgetProps) {
  const { data, isLoading } = useWidgetData(sourceId, `stat-${widget.reportCode}`);
  const { statField, label, aggregation, color } = widget.config;

  const rows = data ?? [];
  const value = rows.length > 0 ? currencyFmt.format(aggregate(rows, statField, aggregation)) : '—';

  return (
    <div data-testid="stat-widget">
      <StatCard
        title={label}
        value={value}
        accentColor={accentMap[color || 'blue'] ?? accentMap.blue}
        loading={isLoading}
      />
    </div>
  );
}
